// src/modules/app-views/_apps/appsindico/units/pages/Document/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SaveOutlined } from '@ant-design/icons';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const unitsDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: <SaveOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ moduleContext }) => moduleContext?.formContext?.submitForm?.(),
    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default unitsDocumentActionButton;
